import GridTexsSortantController from './grid-dd-sortant.controller';
import Template from './grid-dd-sortant.html';

export default {
	bindings: {
		loading: '=',
		table: '=',
		pipe: '@'
	},
	controller: GridTexsSortantController,
	template: Template
};
